module.exports = __webpack_public_path__ + "static/media/02zhanwuyuan2.dafd8f1b.png";